import { render, staticRenderFns } from "./VGermanInvoice.vue?vue&type=template&id=36683b01&"
import script from "./VGermanInvoice.vue?vue&type=script&lang=js&"
export * from "./VGermanInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports